import axios from "axios";
import { apiUrl } from "../url";
import { postRequest } from "../httpMethods";
import { postSSORequest } from "../ssoApi";

 export const plainAxios = axios.create({
  baseURL: apiUrl,
  timeout: 150000,
  withCredentials: true,
});

// Logout belongs to the SSO backend (different port/base path)
export const postLogout = () => postSSORequest("/auth/logout", {});

export const postNodeLogout = () => postRequest("logout", {});

// Other auth requests use the standard node API
export const postLogin = (payload) => postRequest("auth/login", payload);
